"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentListFilter = exports.allotmentListFilterEffects = exports.allotmentListFilterConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Multiple_1 = require("../../../CheckBox/Multiple");
const stable_1 = require("../../../Form/Field/DateRange/stable");
const SearchUser_1 = require("../../../Form/Field/SearchUser");
const utils_1 = require("../../../Form/Field/SearchUser/utils");
require("./index.scss");
exports.className = 'allotment-list-filter';
const allotmentInvoicedStatusLabels = {
    open: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:open', defaultMessage: 'Open' })),
    invoiced: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/Filter:invoiced', defaultMessage: 'Invoiced' })),
};
const allotmentListFilterConfig = (value) => {
    var _a;
    return ({
        type: 'object',
        shape: {
            agent: {
                type: 'object',
                optional: true,
            },
            departure: {
                type: 'object',
                optional: true,
                modificators: 'together',
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                            nextYearsCount: dateTime_1.bookingNextYearsCount,
                        },
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                            nextYearsCount: dateTime_1.bookingNextYearsCount,
                            notAllowedBeforeDate: (_a = value === null || value === void 0 ? void 0 : value.departure) === null || _a === void 0 ? void 0 : _a.from,
                        },
                    },
                },
            },
            invoicedStatus: {
                type: 'array',
                optional: true,
                items: [
                    'open',
                    'invoiced',
                ],
                modificators: 'inline',
            },
        },
    });
};
exports.allotmentListFilterConfig = allotmentListFilterConfig;
exports.allotmentListFilterEffects = [
    {
        target: ['departure', 'from'],
        dependent: [
            ['departure', 'to'],
        ],
    },
];
const AllotmentListFilter = (props) => {
    const { field, reset } = props;
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement(SearchUser_1.SearchUser, { ...field(['agent']), toItem: utils_1.mapAgentToUserItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:SearchAgent', defaultMessage: 'Search Agent' }), additionClassNames: `${exports.className}__agent-list` }),
        react_1.default.createElement(stable_1.FormFieldDateRangeStable, { ...field(['departure']), fromField: {
                ...field(['departure', 'from']),
                label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:DepartureFrom', defaultMessage: 'Departure from' })),
            }, toField: {
                ...field(['departure', 'to']),
                label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:DepartureTo', defaultMessage: 'To' })),
            }, additionClassNames: `${exports.className}__departure` }),
        react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['invoicedStatus']), toItem: (itemValue) => ({
                value: itemValue,
                label: allotmentInvoicedStatusLabels[itemValue],
            }), title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:Status', defaultMessage: 'Status:' }) }),
        react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/Filter:ResetButton', defaultMessage: 'Reset' }), onClick: reset, modificators: ['ascetic', 'block'], additionClassNames: `${exports.className}__reset` })));
};
exports.AllotmentListFilter = AllotmentListFilter;
//# sourceMappingURL=index.js.map